/** メモ (NotionEditor) のショートカット定義。キーは parseShortcutKeys に渡す `mod+alt+1` 形式 */

export type NotionBlockShortcutId =
  | 'paragraph'
  | 'heading1'
  | 'heading2'
  | 'heading3'
  | 'taskList'
  | 'bulletList'
  | 'orderedList'
  | 'toggle'
  | 'codeBlock'
  | 'blockquote'
  | 'callout'

type BlockShortcut = {
  label: string
  keys: string
  /** KeyboardEvent.code。macOS の Option+数字は特殊文字になるため code で判定する */
  code: string
}

export const NOTION_BLOCK_SHORTCUTS: Record<NotionBlockShortcutId, BlockShortcut> = {
  paragraph: { label: 'テキスト', keys: 'mod+alt+0', code: 'Digit0' },
  heading1: { label: '見出し1', keys: 'mod+alt+1', code: 'Digit1' },
  heading2: { label: '見出し2', keys: 'mod+alt+2', code: 'Digit2' },
  heading3: { label: '見出し3', keys: 'mod+alt+3', code: 'Digit3' },
  taskList: { label: 'ToDo リスト', keys: 'mod+alt+4', code: 'Digit4' },
  bulletList: { label: '箇条書き', keys: 'mod+alt+5', code: 'Digit5' },
  orderedList: { label: '番号付きリスト', keys: 'mod+alt+6', code: 'Digit6' },
  toggle: { label: 'トグル', keys: 'mod+alt+7', code: 'Digit7' },
  codeBlock: { label: 'コードブロック', keys: 'mod+alt+8', code: 'Digit8' },
  blockquote: { label: '引用', keys: 'mod+alt+9', code: 'Digit9' },
  callout: { label: 'Callout', keys: 'mod+alt+-', code: 'Minus' },
}

type ShortcutSection = {
  title: string
  items: { label: string; keys: string }[]
}

export const NOTION_SHORTCUT_SECTIONS: ShortcutSection[] = [
  {
    title: 'ブロック',
    items: Object.values(NOTION_BLOCK_SHORTCUTS).map(({ label, keys }) => ({ label, keys })),
  },
  {
    title: '文字の書式',
    items: [
      { label: '太字', keys: 'mod+b' },
      { label: '斜体', keys: 'mod+i' },
      { label: '下線', keys: 'mod+u' },
      { label: '取り消し線', keys: 'mod+shift+s' },
      { label: 'インラインコード', keys: 'mod+e' },
      { label: 'ハイライト', keys: 'mod+shift+h' },
      { label: '上付き', keys: 'mod+.' },
      { label: '下付き', keys: 'mod+,' },
    ],
  },
  {
    title: '編集',
    items: [
      { label: 'コマンドメニュー', keys: '/' },
      { label: '元に戻す', keys: 'mod+z' },
      { label: 'やり直し', keys: 'mod+shift+z' },
      { label: '段落内で改行', keys: 'shift+enter' },
      { label: 'インデント', keys: 'tab' },
      { label: 'インデント解除', keys: 'shift+tab' },
    ],
  },
]

/** 物理キーボードを使う端末か（タッチ端末ではショートカット表示を出さない） */
export const canUseKeyboardShortcuts = (): boolean =>
  typeof window !== 'undefined' && window.matchMedia('(hover: hover) and (pointer: fine)').matches
